/* eslint-disable indent */
/* global $ instantsearch */
import {
  renderEmpty,
  renderPagination,
  renderPerson,
  renderProject,
  renderVoice,
} from './templates';

class GlobalSearch {
  constructor(searchClient, locale) {
    this.$body = $('body');
    this.locale = locale;

    this.search = instantsearch({
      indexName: 'prod_global',
      searchClient,
      routing: true
    });

    this.init();
  }

  init() {
    this.addGlobalWidgets();
    this.search.start();
  }

  addGlobalWidgets() {
    let placeholder = this.locale === 'zh' ? '搜索' : 'Search Sasaki';
    this.search.addWidget(
      instantsearch.widgets.searchBox({
        container: '#searchbox',
        placeholder: placeholder,
        templates: {
          submit: 'Submit search query',
          reset: 'Reset search query',
        },
      }),
    );

    this.search.addWidget(instantsearch.widgets.configure({ hitsPerPage: 24 }));

    const customHits = instantsearch.connectors.connectHits(this.renderGlobalHits.bind(this));
    this.search.addWidget(customHits({
      container: $('#hits'),
      transformItems: items => items.map(item => ({
        ...item,
        locale: this.locale
      })),
     }));

    const customPagination = instantsearch.connectors.connectPagination(renderPagination);
    this.search.addWidget(customPagination({
      container: $('#pagination'),
      locale: this.locale
    }));

    setTimeout(() => {
      this.addAccessibleLabel();
    }, 20);

    this.search.on('render', () => {
      const $archiveFeed = this.$body.find('.archive-feed');
      $archiveFeed.removeClass('js-content-is-loaded');

      setTimeout(() => {
        $archiveFeed.addClass('js-content-is-loaded');
      }, 500)
    });
  }

  addAccessibleLabel() {
    const searchInput = $('.ais-SearchBox-input');
    searchInput
      .attr('id', 'algolia-searchbox')
      .prepend(`<label for="algolia-searchbox" class="visually-hidden">Search Input</label>`);
  }

  renderGlobalHits({ hits, results, widgetParams }) {
    if (results && hits.length === 0) {
      $(widgetParams.container).html(renderEmpty(results.query));
      return;
    }

    $(widgetParams.container).html(
      `${hits
        .map(item => {
          switch (item.content) {
            case 'Project':
              return renderProject(item, instantsearch);
            case 'Page':
              return renderProject(item, instantsearch);
            case 'Project Type':
              return renderProject(item, instantsearch);
            case 'Person':
              return renderPerson(item, instantsearch);
            case 'Voices':
              return renderVoice(item, instantsearch);
          }
        })
        .join('')}`,
    );
  }
}

export default GlobalSearch;
